import { mapExchange } from '@urql/vue'

export type HeadersOrCallback =
    | Record<string, string>
    | (() => Record<string, string>)

export function addHeaderExchange(newHeaders: HeadersOrCallback) {
    return mapExchange({
        onOperation(operation) {
            let fetchOptions = operation.context.fetchOptions || {}

            if (typeof fetchOptions === 'function') {
                fetchOptions = fetchOptions()
            }

            const h =
                typeof newHeaders === 'function' ? newHeaders() : newHeaders

            const headers = fetchOptions.headers || {}
            if (typeof Headers !== 'undefined' && headers instanceof Headers) {
                Object.entries(h).forEach((h) => {
                    headers.set(h[0], h[1])
                })
            } else if (Array.isArray(headers)) {
                Object.entries(h).forEach((h) => {
                    headers.push([h[0], h[1]])
                })
            } else if (typeof headers === 'object' && !('get' in headers)) {
                Object.entries(h).forEach((h) => {
                    headers[h[0]] = h[1]
                })
            } else {
                // eslint-disable-next-line no-console
                console.error('Unknown type of Headers')
            }

            return {
                ...operation,
                context: {
                    ...operation.context,
                    fetchOptions: {
                        ...fetchOptions,
                        headers,
                    },
                },
            }
        },
    })
}
